<template>
<div class="flex">
    <div class="grouping">
        <label>Active In Program</label>

        <div class="subgrouping">
            <div class="subitem">
                <label>Total Uploaded</label>
                <span class="ta-c">{{ rowData.stats.upload_count }}</span>
            </div>

            <div class="subitem">
                <label>Total In Program</label>
                <span class="ta-c">{{ rowData.stats.tenant_count }}</span>
            </div>

            <div class="subitem">
                <label>Audit Letters Sent</label>
                <span class="ta-c">{{ rowData.stats.audit_letters_sent }}</span>
            </div>

            <div class="subitem">
                <label>Reminder Letters Sent</label>
                <span class="ta-c">{{ rowData.stats.reminder_letters_sent }}</span>
            </div>

            <div class="subitem">
                <label>Welcome Letters Sent</label>
                <span class="ta-c">{{ rowData.stats.welcome_letters_sent }}</span>
            </div>
        </div>
    </div>

    <div class="grouping">
        <label>Results</label>

        <div class="subgrouping">
            <div class="subitem">
                <label>Selected Coverage</label>
                <span class="ta-c">{{ rowData.stats.selected_coverage }}</span>
            </div>

            <div class="subitem">
                <label>Coverage Confirmed</label>
                <span class="ta-c">{{ rowData.stats.confirmed_payment }}</span>
            </div>

            <div class="subitem">
                <label>Provided Proof</label>
                <span class="ta-c">{{ rowData.stats.provided_proof }}</span>
            </div>

            <div class="subitem">
                <label>Opted Out</label>
                <span class="ta-c">{{ rowData.stats.opted_out }}</span>
            </div>

            <div class="subitem">
                <label>Moved Out</label>
                <span class="ta-c">{{ rowData.stats.moved_out }}</span>
            </div>

            <div class="subitem">
                <label>Bad Address</label>
                <span class="ta-c">{{ rowData.stats.bad_address }}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        rowData: {
            required: true,
            type: Object
        },

        rowIndex: {
            type: Number
        }
    }
}
</script>

<style scoped>
.grouping {
    background: #fff;
    border: 1px solid #e8e8e8;
}

.grouping + .grouping {
    margin-left: 20px;
}

.grouping > label {
    background: #83dbb3;
    color: #444;
    padding: 8px;
    text-align: center;
}

.subgrouping {
    display: flex;
}

.subitem {
    display: flex;
    flex-direction: column;
    padding: 0 8px 8px;
}

.subitem > label {
    border-bottom: 1px solid #efefef;
    color: #444;
    padding: 8px 8px 4px;
    text-align: center;
}

.subitem > span {
    padding-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/list-facilities-page/FacilityStatsDetailRow.vue